import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

import {ClientInboxEditFormFields} from './types';

export type UseChangeClientInboxErrorResponse = Api.Response.Failure<
    keyof ClientInboxEditFormFields
>;

export type UseChangeClientInboxProps = {
    clientMid: string;
    formData: ClientInboxEditFormFields;
};

export type UseChangeClientInboxSuccessResponse =
    Api.Response.Template.SuccessBasicMessage;

export const useChangeClientInbox = (): UseMutationResult<
    UseChangeClientInboxSuccessResponse,
    UseChangeClientInboxErrorResponse,
    UseChangeClientInboxProps
> => {
    const locale = useLocale();

    return useMutation<
        UseChangeClientInboxSuccessResponse,
        UseChangeClientInboxErrorResponse,
        UseChangeClientInboxProps
    >(({clientMid, formData}: UseChangeClientInboxProps) =>
        request({
            formData: toSnakeCase(formData),
            locale,
            method: 'POST',
            url: `/home/client/${clientMid}/clientinbox/edit/post`,
        }),
    );
};
